const markerBoundary = '\u2063';
const zeroDigit = '\u200B';
const oneDigit = '\u200C';
const markerPattern = /\u2063([\u200B\u200C]+)\u2063/g;

const keysByIndex: string[] = [];
const indexByKey: { [key: string]: number } = {};

function indexOf(key: string): number {
    if (indexByKey[key] === undefined) {
        indexByKey[key] = keysByIndex.length;
        keysByIndex.push(key);
    }
    return indexByKey[key];
}

export function markTranslation(text: string, key: string): string {
    const digits = indexOf(key).toString(2).replace(/0/g, zeroDigit).replace(/1/g, oneDigit);
    return `${text}${markerBoundary}${digits}${markerBoundary}`;
}

export function readTranslationKeys(text: string | null): string[] {
    const keys: string[] = [];
    if (!text) {
        return keys;
    }

    const pattern = new RegExp(markerPattern.source, 'g');
    let match = pattern.exec(text);
    while (match !== null) {
        const binary = match[1].replace(/\u200B/g, '0').replace(/\u200C/g, '1');
        const key = keysByIndex[parseInt(binary, 2)];
        if (key !== undefined && keys.indexOf(key) === -1) {
            keys.push(key);
        }
        match = pattern.exec(text);
    }

    return keys;
}

export function readTranslationKey(text: string | null): string | null {
    const keys = readTranslationKeys(text);
    return keys.length > 0 ? keys[0] : null;
}

export function stripTranslationKeyMarkers(text: string | null): string {
    return (text || '').replace(markerPattern, '');
}
